import {create} from "zustand";
import {ProcessInstanceType} from "@/src/shared/schemas";

interface UseProcessInstanceStoreProps {
    processInstance: ProcessInstanceType;
    setProcessInstance: (processInstance: ProcessInstanceType) => void;
}


export const useProcessInstanceStore = create<UseProcessInstanceStoreProps>((set, get) => ({
    processInstance: {
        id: "",
        processId: "",
        activeStepId: "",
        createdAt: "",
        updatedAt: "",
        contextInstance: {
            id: "",
            variables: []
        },
        // stepTimes: [],
        order: {
            id: "",
            number: "",
            status: "",
            transaction: {
                id: "",
                status: "",
                billId: "",
            }
        },
        activeStep: {
            id: "",
            name: "",
            code: "",
            order: 0,
            page: {
                id: "",
                name: "",
                description: "",
                components: []
            },
            orderStatus: "",
            rule: {
                id: "",
                xml: "",
                code: ""
            }
        }
    },
    setProcessInstance: (processInstance: ProcessInstanceType) => {
        set(() => ({processInstance}));
    }
}));
